import { forEach, set, get } from 'lodash'
import extractDataValue from './extract-data-value'

/**
 * Get inserted (our custom) style by selector and rule.
 */

export function getResponsiveValues( {
	cssProperty,
	cssSelectorCustom = window.Stylist.cssSelectorCustom } ) {
	const responsiveValues = []
	const currentResponsiveSize = window.stlst_legacy.get_media_condition()

	const valuesBySize = get( window.Stylist.cachedCssValues, '["' + cssSelectorCustom + '"]', {} )

	forEach( valuesBySize, ( values, responsiveSize ) => {
		if ( currentResponsiveSize !== responsiveSize && cssProperty in values ) {
			const label = responsiveSize.replace( '(', '' ).replace( ')', '' )
			responsiveValues.push( {
				size: responsiveSize,
				label: label,
				value: values[ cssProperty ] } )
			// set( responsiveValues, responsiveSize, values[ cssProperty ] )
		}
	} )

	return responsiveValues.reverse()
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-responsive-values.js